import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';


import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { contactPay, payMeth, reserve,viaPay } from '../../../slices/modalSlice';
class PayMethForm extends Component {

    constructor(props) {
        super(props);

      }
 


    toogleClose = () =>this.props.dispatch(payMeth())
    retourMeth = () =>this.props.dispatch(reserve())

    retourFunc = () =>{
      this.toogleClose()
      this.retourMeth()
    } 

    contactPay = () => this.props.dispatch(contactPay())


    viaPay = () => this.props.dispatch(viaPay())

    
    viaPayFunc = () =>{
      this.toogleClose();
      this.viaPay()
    }
    contactPayFunc = () =>{
      this.toogleClose();
      this.contactPay()
    }    
    render() {
      
        return (
            <div>
              <Modal isOpen={this.props.payMeth} toggle={this.toogleClose} contentClassName="reserveModal" centered={true} size="lg">
                   <ModalHeader className="modalHeader" toggle={this.toogleClose}><center className="text-center ml-md-3">Réserver maintenant-Hébergement</center></ModalHeader>
                   <ModalBody className="container">
                      <p className="text-center grayTxt">Veuillez choisir une méthode de paiement</p>
                      <div className="container d-block  d-md-flex justify-content-between mb-3">
                          <div id="contactPay" className="container methDivs col-12 col-md-6 d-flex flex-column align-items-center mr-3 mb-2 mb-md-0">
                              <Button id="contactPayBtn" onClick={this.contactPayFunc}>Contacter l'annonceur pour le paiement<i className="ml-3"><svg id="Groupe_538" data-name="Groupe 538" xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 45 33.962">
                                 <path id="Tracé_490" data-name="Tracé 490" d="M8083.5,959.5v24.843h32.308V959.5Z" transform="translate(-8077.494 -951.881)" fill="none" stroke="#fff" stroke-width="3"/>
                                 <path id="Tracé_491" data-name="Tracé 491" d="M8095.5,959.5l1.22,5.5h4.876l1.22-5.5Z" transform="translate(-8077.521 -951.881)" fill="none" stroke="#fff" stroke-linejoin="round" stroke-width="3"/>
                                 <g id="Rectangle_1103" data-name="Rectangle 1103" fill="none" stroke="#fff" stroke-width="3">
                                 <rect width="45" height="9" rx="2" stroke="none"/>
                                 <rect x="1.5" y="1.5" width="42" height="6" rx="0.5" fill="none"/>
                                 </g>
                                 </svg></i>
                              </Button>
                              <p className="text-center methExpls">Voir avec l'annonceur pour trouver le moyen de paiement qui vous arrange</p>
                          </div>
                          <div id="viaPay" className="container methDivs col-12 col-md d-flex flex-column align-items-center">
                              <Button id="viaPayBtn" onClick={this.viaPayFunc}>Paiement Sécurisé via Ghurfaty<i id="reserveIcon">
                               <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 58.98 52.006">
                                 <path id="Path_581" data-name="Path 581" d="M901.8,613.8l-3.391-3.748-10.377,9.387a25.72,25.72,0,1,0,2.943,4.154Zm-12.515,22.5a20.741,20.741,0,1,1-5-13.47l-17.541,15.867-6.561-6.965L856.5,635.2l9.958,10.57,20.653-18.682A20.568,20.568,0,0,1,889.284,636.3Z" transform="translate(-842.819 -610.051)" fill="#fff"/>
                               </svg>
                                 </i>
                             </Button>
                              <p className="text-center methExpls">Payez par CCP/Baridimob, PayPal, Carte de crédit ou en espèces en toute sécurité via notre plateforme</p>
                          </div>
                          
                      </div>
                      <Button onClick={this.retourFunc} className="d-flex align-items-center" id="methRetour"><i className="mr-2"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 11.59 23.584">
                         <path id="down_arrow_icn" d="M23.133,2.27A1.28,1.28,0,0,0,23.261.445,1.32,1.32,0,0,0,21.414.317L11.792,8.583,2.169.317A1.321,1.321,0,0,0,.322.445,1.268,1.268,0,0,0,0,1.293a1.288,1.288,0,0,0,.45.977l10.482,9a1.321,1.321,0,0,0,1.719,0Z" transform="translate(11.59) rotate(90)" fill="#fff"/>
                          </svg>
                          </i><span>Retour</span>
                      </Button>
                   </ModalBody>
              </Modal>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
    
      payMeth: state.modal.payMeth,
 
      
    }
  }
export default withRouter(connect(mapStateToProps)(PayMethForm));
